import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2 } from 'lucide-react';
import { Button } from '../ui/button';
import { clientsData } from '../../data/companyData';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};

// Show only first 12 clients on home page (3 rows of 4)
const displayClients = clientsData.slice(0, 12);

export const ClientsSection = () => {
  return (
    <section 
      className="py-24 md:py-32 bg-[#f5f7fb]"
      data-testid="clients-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-[#001582]/10 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 bg-[#FFC107] rounded-full" />
            <span className="text-[#001582] text-sm font-semibold uppercase tracking-wider">Klien</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-6">
            Dipercaya oleh <span className="text-[#001582]">Perusahaan</span> Terkemuka
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Kami bangga telah bekerja sama dengan berbagai perusahaan terkemuka di Indonesia.
          </p>
        </motion.div>

        {/* Clients Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
        >
          {displayClients.map((client, index) => (
            <motion.div
              key={client.name}
              variants={itemVariants}
              className="group"
            >
              <div className="bg-white rounded-2xl border border-slate-100 p-4 h-28 flex flex-col items-center justify-center hover:border-[#001582]/20 hover:shadow-lg transition-all duration-300">
                <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center mb-2 group-hover:bg-[#001582]/10 transition-colors overflow-hidden">
                  {client.logo ? (
                    <img 
                      src={client.logo} 
                      alt={client.name}
                      className="w-10 h-10 object-contain"
                    />
                  ) : (
                    <Building2 className="w-5 h-5 text-slate-400 group-hover:text-[#001582] transition-colors" />
                  )}
                </div>
                <p className="text-xs text-slate-600 text-center leading-tight line-clamp-2 group-hover:text-[#001582] transition-colors">
                  {client.name.replace('PT ', '')}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mt-12"
        >
          <Link to="/klien">
            <Button 
              variant="outline"
              className="border-2 border-[#001582] text-[#001582] hover:bg-[#001582] hover:text-white font-semibold rounded-xl"
              data-testid="clients-cta"
            >
              Lihat Semua Klien
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsSection;
